import React from 'react'
import { Link } from 'react-router-dom'

import '../styles/landing.css'

import { FaStar } from "react-icons/fa";
import images from '../assets/images'

const Landing = () => {
  return (
    <>
      <div className="landing">
        <div className="hdr">
          <h1>Trade Smarter With <span>Summit Capital</span></h1>
          <p>AI-POWERED TRADING SIGNALS</p>
          <div className="inspo">
            <div className="imgs"></div>
            <div className="txts">
              <p>Join <span>95,000+</span> traders already winniing</p>
            </div>
          </div>
        </div>
        <div className="phoneAnime">
          <div className="lft">
            <div className="img" style={{ backgroundImage: `url(${images.phone1})` }}></div>
          </div>
          <div className="mid">
            <div className="img" style={{ backgroundImage: `url(${images.phone2})` }}></div>
          </div>
          <div className="ryt">
            <div className="img" style={{ backgroundImage: `url(${images.phone3})` }}></div>
          </div>
        </div>
        <div className="rtng">
          <div className="strs">
            <div className="stars-icons">
              <FaStar />
              <FaStar />
              <FaStar />
              <FaStar />
              <FaStar />
            </div>
            <p>Rated 5 stars on <span>Whop</span></p>
          </div>
          <div className="rvw">
            <p>1.2k reviews</p>
          </div>
        </div>
        <div className="reg">
          <h3>AI powered <span>buy & sell</span> signals</h3>
          <div className="glw">
            <Link to="/auth">Start Trading Now</Link>
          </div>
        </div>
        <div className="pwdby">
          <div className="hdd">
            <p>DATA POWERED BY</p>
            <div className="carousel">
              <ul>
                <li>
                  <div className="img" style={{ backgroundImage: `url(${images.pwd1})` }}></div>
                </li>
                <li>
                  <div className="img" style={{ backgroundImage: `url(${images.pwd2})` }}></div>
                </li>
                <li>
                  <div className="img" style={{ backgroundImage: `url(${images.pwd3})` }}></div>
                </li>
                <li>
                  <div className="img" style={{ backgroundImage: `url(${images.pwd4})` }}></div>
                </li>
              </ul>
              <ul aria-hidden>
                <li>
                  <div className="img" style={{ backgroundImage: `url(${images.pwd1})` }}></div>
                </li>
                <li>
                  <div className="img" style={{ backgroundImage: `url(${images.pwd2})` }}></div>
                </li>
                <li>
                  <div className="img" style={{ backgroundImage: `url(${images.pwd3})` }}></div>
                </li>
                <li>
                  <div className="img" style={{ backgroundImage: `url(${images.pwd4})` }}></div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Landing